export const concatenateObjectValuesWithComma = (
  obj: Record<string, string>,
  order: string[],
) => {
  const concatenatedValues = order
    .map((key) => obj[key] || '')
    .filter((value) => value !== '')
  return concatenatedValues.join(', ')
}

export const concatenateObjectValuesWithoutComma = (
  obj: Record<string, string>,
  order: string[],
) => {
  const concatenatedValues = order
    .map((key) => obj[key] || '')
    .filter((value) => value !== '')

  return concatenatedValues.join(' ')
}
